import React, {useState} from 'react';
import {Modal, Button, Form, Dropdown, TextArea} from 'semantic-ui-react';
import { useDataInspector } from '../../../providers/DataInspectorProvider';
import styles from '../DataInspector.module.css';


export const EditPointModal = ({open, setOpen, pointData, setPointData}) => {
    const [edit, setEdit] = useState(false);

    const [value, setValue] = useState(null);
    const [error, setError] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);

    const {updatePointData} = useDataInspector();

    const clearStates = () => {
        setValue(null);
        setError(null);
        setErrorMessage(null);
    };

    const handleClose = () => {
        setOpen(false);
        setPointData(null);
        clearStates();
    };

    const handleBlur = (e) => {
        setEdit(true);
    };

    const handleSave = (e) => {
        const submit = {
            id: null,
            objectId: pointData.objectId,
            normalized_time: pointData.normalizedTime,
            pointId: pointData.point.pointId,
            timestamp: pointData.point.timestamp,
            value: value,
            error: error === 'true' ? true : false,
            error_message: errorMessage
        }
        updatePointData(submit).then((x) => {
            handleClose();
            alert("Point data updated successfully");
        }).catch((e) => {
            alert("Error updating point data");
        });
    };

  return (
    <>
        <Modal
          closeIcon
          onClose={() => handleClose()}
          onOpen={() => setOpen(true)}
          open={open}
          style={{textAlign: 'left'}}
          size={'tiny'}
        >
          <Modal.Header>Edit Point Data</Modal.Header>
          <Modal.Content>
            <Form>
                <Form.Field className={styles.editPointField}>
                    <label>Point Id</label>
                    <div>{pointData?.point ?  pointData.point.pointId : 0}</div>
                </Form.Field>
                <Form.Field className={styles.editPointField}>
                    <label>Point Code</label>
                    <div>{pointData?.point ?  pointData.point.pointCode : ""}</div>
                </Form.Field>
                <Form.Field className={styles.editPointField}>
                    <label>Point Timestamp</label>
                    <div>{pointData?.point ?  pointData.point.timestamp : 0}</div>
                </Form.Field>
                <Form.Field className={styles.editPointField}>
                    <label>Point Value</label>
                    <div>
                        <Form.Input
                            name={`value`}
                            type={'number'}
                            defaultValue={pointData?.point ?  pointData.point.value : 0}
                            placeholder="Value"
                            onBlur={e => {
                                setValue(e.target.value);
                                handleBlur();
                            }}
                        />
                    </div>
                </Form.Field>
                <Form.Field className={styles.editPointField}>
                    <label>Error</label>
                    <div>
                        <Dropdown
                            name={`error`}
                            type={'number'}
                            defaultValue={pointData?.point.error ==='True' ?  'true' : 'false'}
                            placeholder="Error State"
                            className={styles.editPointDropdown}
                            options={[
                                {key: 'true', text: 'True', value: 'true'},
                                {key: 'false', text: 'False', value: 'false'},
                            ]}
                            selection
                            onChange={(e, selected) => {
                                setError(selected.value);
                                handleBlur();
                            }}
                        />
                    </div>
                </Form.Field>
                <Form.Field className={styles.editPointField}>
                    <label>Error Message</label>
                    <div>
                        <TextArea
                            name={`error`}
                            type={'textarea'}
                            defaultValue={pointData?.point.errorMessage !== 'N/A' ?  pointData?.point.errorMessage : null}
                            placeholder="Error Message"
                            onBlur={e => {
                                setErrorMessage(e.target.value);
                                handleBlur();
                            }}
                        />
                    </div>
                </Form.Field>
            </Form>
          </Modal.Content>
          <Modal.Actions>
            <Button onClick={() => handleClose() }>Close</Button>
            {edit ? <Button onClick={() => handleSave() } primary>Save</Button> : null}
          </Modal.Actions>
        </Modal>
    </>
  );
};
